import { createUser } from "../../api";
import { useState } from "react";

export function RegisterUser() {

    const [user, setUser] = useState({
        email: '',
        firstName: '',
        lastName: '',
        occupation: '',
        role: '',
        practice: '',
        password: ''
    })

    async function handleSubmit(e) {
        e.preventDefault()
        let response = await createUser(user)
        console.log("submitting new user:" , user)
        if (response.status !== 200) {
            alert(`${response.status} user account not created`)
        }
       
    }

    function handleChange(e) {
        setUser({ ...user, [e.target.name]: e.target.value })
    }
       

    return (
        <form onSubmit={handleSubmit}>
            <input placeholder={"email"} onChange={handleChange} name="email" required maxLength={20}/>
            <input placeholder={"firstName"} onChange={handleChange} name="firstName" required maxLength={40}/>
            <input placeholder={"lastName"} onChange={handleChange} name="lastName" required maxLength={20}/>
            <input placeholder={"occupation"} onChange={handleChange} name="occupation" required maxLength={20}/>
            <input placeholder={"role"} onChange={handleChange} name="role" required maxLength={20}/>
            <input placeholder={"practice"} onChange={handleChange} name="practice" required maxLength={20}/>
            <input placeholder={"password"} type="password" onChange={handleChange} name="password" required maxLength={20}/>
            <button type="submit">CreateAccount</button>
        </form>
    )

}